import { c as _c } from "react/compiler-runtime";
import { useSheet } from "@website/ui/sheet/sheet.hook";
import styles from "@website/ui/sheet/sheet.module.scss";
import { SheetPropertiesType } from "@website/ui/sheet/sheet.types";
import { FC } from "react";
export const Sheet: FC<SheetPropertiesType> = properties => {
  const $ = _c(7);
  const {
    animate: t0,
    xGap: t1,
    xPosition: t2,
    yPosition: t3,
    children,
    fillContainerWidth,
    className
  } = properties;
  const animate = t0 === undefined ? "bottom" : t0;
  const xGap = t1 === undefined ? "0px" : t1;
  const xPosition = t2 === undefined ? "start" : t2;
  const yPosition = t3 === undefined ? "start" : t3;
  const {
    rootProperties,
    animateState
  } = useSheet(properties);
  if (animateState === "initial" || animateState === "entered" || animateState === "entering" || animateState === "exiting") {
    const t4 = `${animateState === "entered" ? "" : "pointer-events-none"} ${styles.container} ${fillContainerWidth ? styles["fill-container-width"] : ""} ${styles[`animate-${animate}`]} ${styles[animateState]} ${styles[`x-${xPosition}`]} ${styles[`y-${yPosition}`]} } ${className}`;
    let t5;
    if ($[0] !== xGap) {
      t5 = {
        marginTop: xGap
      };
      $[0] = xGap;
      $[1] = t5;
    } else {
      t5 = $[1];
    }
    let t6;
    if ($[2] !== children || $[3] !== rootProperties || $[4] !== t4 || $[5] !== t5) {
      t6 = <div className={t4} style={t5} {...rootProperties}>{children}</div>;
      $[2] = children;
      $[3] = rootProperties;
      $[4] = t4;
      $[5] = t5;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  return null;
};